// extracted by css-extract-rspack-plugin
module.exports =  {"root":"LoadingOverlay__root___fPyU3"};